import PropTypes from "prop-types";

import { FLYOUT_BODY_CLASSES } from "./Flyout.styles";

const FlyoutBody = ({ children = null, className = "", style = undefined }) => (
  <div className={`${FLYOUT_BODY_CLASSES} ${className || ""}`} style={style}>
    {children}
  </div>
);

FlyoutBody.propTypes = { children: PropTypes.node, className: PropTypes.string, style: PropTypes.shape() };

export default FlyoutBody;
